import type { JSX } from "react/jsx-runtime";
import type { AdGalleryItem } from "../../../../../actions/ad/adGallery";
import { decode } from "../utils.ts";

type Props = {
  ad: AdGalleryItem;
  isActive: boolean;
  originForTracking: string;
};

export function AdGalleryItem({
  ad,
  isActive,
  originForTracking,
}: Props): JSX.Element {
  const adTitle = decode(ad.title);

  return (
    <li className="w-[160px] cursor-pointer rounded-xsmall bg-surface shadow-soft hover:shadow-elevation hover:transition-all hover:duration-short2">
      <a
        className="list-item no-underline"
        href={ad.linkUrl}
        tabIndex={isActive ? 0 : -1}
        data-gaevent={`${originForTracking},GalleryVIPClick`}
        data-gaevent-direct="true"
      >
        <div className="flex h-[109px] items-center justify-center pt-xsmall">
          <img
            className="max-h-full max-w-full object-cover"
            alt={ad.imageAltText}
            width="140"
            height="105"
            src={ad.imageUrl}
            loading="lazy"
          />
        </div>
        <div className="relative p-xsmall text-onSurface">
          <h3 className="m-none truncate text-bodySmall">{adTitle}</h3>
          <p className="my-xxsmall truncate text-bodySmall font-regular text-onSurfaceNonessential">
            {ad.location}
          </p>
          {ad.priceString && isActive && (
            <div className="absolute right-[-6px] top-[-34px] inline-block max-w-[100px] cursor-pointer bg-primary px-xxsmall py-xxxsmall text-right text-bodySmallStrong text-onPrimary">
              <span>{ad.priceString}</span>
              <span className="absolute -bottom-xxsmall right-xxxsmall rotate-45 border-4 border-transparent border-r-interactive" />
            </div>
          )}
        </div>
      </a>
    </li>
  );
}
